import React from 'react'

function AllCourses() {
  return (
    <div>AllCourses</div>
  )
}

export default AllCourses